import { connect } from 'react-redux';
import { Redirect, Route, RouteProps } from 'react-router';
import { AuthType } from '.';
import { RootStateType } from '../redux-store/reducers';

function ProtectedRoute({
    token,
    isLoggedOut,
    component: Component,
    isLoggedIn,
    ...rest
}: AuthType) {
    const _window: any = window;
    const isAuthenticated = !!_window.cordova ? (!!rest.userId ? true : false) : !!isLoggedIn;
    return (
        <Route
            {...rest}
            render={(props) => {
                if (!!isAuthenticated) {
                    return <Component {...props} />;
                } else {
                    return (
                        <Redirect
                            to={{
                                pathname: '/investor/signin',
                                state: {
                                    referrer: isLoggedOut ? null : props.location.pathname,
                                    searchParams: isLoggedOut ? null : props.location.search,
                                },
                            }}
                            from={props.location.pathname}
                        />
                    );
                }
            }}
        />
    );
}
export default connect(({ authReducer }: RootStateType) => {
    return {
        token: authReducer.token,
        isLoggedOut: authReducer.isLoggedOut,
        isLoggedIn: authReducer.isLoggedIn,
        userId: authReducer.pan,
    };
}, {})(ProtectedRoute);
